module.exports = __webpack_public_path__ + "static/media/sistemas solares termicos residencial y publico.c10ec13d.gif";